module.exports = __webpack_public_path__ + "img/invitation.6b6e0d6d.svg";